module.exports = __webpack_public_path__ + "static/media/icon-term.1ebdb274.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-term.svg
// module id = 560
// module chunks = 0